import type {CheckoutPerBookingService} from "@/scopes/checkout/domain/types";
import {produce} from "immer";

interface PerBookingServicePayload {
  value: string;
}

export function updatePerBookingService(payload: PerBookingServicePayload) {
  return produce((service: CheckoutPerBookingService) => {
    service.selectedValue = payload.value;
    const participantIds = Object.keys(service.participants);
    for (const participantId of participantIds) {
      service.participants[participantId].selectedValue = payload.value;
    }
  });
}
